<div class="forgot-page">

  <div class="account-wrapper">

    <div class="logo-wrapper">
      <img src="assets/img/IMG_20260710_164659.png" alt="Aelumni Logo" class="brand-logo" />
    </div>

    <h2 class="account-title">Forgot Password?</h2>
    <p class="account-subtitle">No worries, we'll send you reset instructions</p>

    <form [formGroup]="form">

      <div class="form-group">
        <label>User Email</label>
        <div class="input-wrapper">
          <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2">
            <path d="M22 6l-10 7L2 6" />
            <path d="M2 6h20v12H2z" />
          </svg>
          <input class="form-control" type="text" formControlName="email" id="email" placeholder="Enter your email" />
        </div>
        <div *ngIf="form.get('email').invalid && (form.get('email').touched || submitted)">
          <small class="text-danger" *ngIf="form.get('email')?.errors?.['required']">
            Email is required
          </small>
          <small class="text-danger" *ngIf="form.get('email')?.errors?.['email']">
            Invalid email format
          </small>
        </div>
      </div>

      <div class="form-group text-center">
        <button class="btn btn-primary account-btn" type="submit" (click)="submit()">
          Send Reset Link
        </button>
      </div>

      <div class="account-footer">
        <a routerLink="/login" class="back-link">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            width="15" height="15">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Login
        </a>
        <span *ngIf="errors!=null" class="msg text-danger">{{errors}}</span>
        <span *ngIf="success!=null" class="msg text-success">{{success}}</span>
      </div>
    </form>
  </div>
</div>